import React, { forwardRef, MutableRefObject } from 'react';
import cn from 'classnames';
import styles from './Button.module.scss';

export const SmallButton = forwardRef(
  (
    { className, children, ...props }: React.ComponentPropsWithoutRef<'button'>,
    ref: MutableRefObject<HTMLButtonElement>,
  ) => (
    <button className={cn(styles.button, styles.smallButton, className)} {...props} ref={ref}>
      {children}
    </button>
  ),
);

export const SmallLinkButton = forwardRef(
  (
    { className, children, ...props }: React.ComponentPropsWithoutRef<'a'>,
    ref: MutableRefObject<HTMLAnchorElement>,
  ) => (
    <a className={cn(styles.button, styles.smallButton, className)} {...props} ref={ref}>
      {children}
    </a>
  ),
);

function Button(
  { className, children, ...props }: React.ComponentPropsWithoutRef<'button'>,
  ref: MutableRefObject<HTMLButtonElement>,
) {
  return (
    <button className={cn(styles.button, className)} {...props} ref={ref}>
      {children}
    </button>
  );
}

export default forwardRef(Button);
